/*
1. 3 same genres in same order
2. 2 same genres in same order
5. 3 same genres in different order
*/
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import intersection from 'lodash/intersection';

// core components
import config from 'config';
import Heading from 'components/Heading/Heading.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import Loader from 'components/Loader';
import MessageInfo from 'components/MessageInfo';
import MatchProfileItemSmallScreen from 'components/MatchProfileItemSmallScreen';
import MatchProfileItemLargeScreen from 'components/MatchProfileItemLargeScreen';
import { displayError } from 'store/actions/errorActions';
import { updateProviderTracks } from 'store/actions/providerTracksActions';
import { getCuratedTracks } from 'services/providerService';
import Store from 'services/StoreService';

// Sections
import CarouselDesktop from './sections/SectionCarouselDesktop.jsx';
import CarouselMobile from './sections/SectionCarouselMobile.jsx';

// Icon components
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import Hidden from '@material-ui/core/Hidden';

const Fynda = ({
  uid,
  favoriteGenres,
  curated,
  updateProviderTracks,
  displayError,
}) => {
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    if (favoriteGenres.length) {
      getMatchingUsers();
    }
  }, [favoriteGenres]);

  useEffect(() => {
    // Do nothing if we already have a curated list
    if (curated && !curated.length && favoriteGenres.length) {
      buildCuratedListFromProvider();
    }
  }, [curated, favoriteGenres]);

  const buildCuratedListFromProvider = async () => {
    try {
      const data = await getCuratedTracks(favoriteGenres);
      if (data.error) throw new Error(data.error);
      // Update app state
      updateProviderTracks({
        type: 'curated',
        tracks: data.slice(0, config.nbOfCuratedSongs),
      });
    } catch (error) {
      console.error(error);
      displayError('Could not retrieve the curated list');
    }
  };

  const getMatchingUsers = async () => {
    const data = await Store.getUsers(100);
    const found = data.reduce((acc, e) => {
      // Discard if no favorite genres
      if (!e.favoriteGenres) return acc;
      // Discard the current user himself
      if (e.uid === uid) return acc;
      // Check what potential common genres are with this user
      const genreMatch = intersection(
        favoriteGenres.slice(0, 3),
        e.favoriteGenres.slice(0, 3)
      );
      // Discard if no common genres
      if (genreMatch.length > 0) {
        acc.push(e);
      }
      return acc;
    }, []);
    setMatches(found.slice(0, 10));
  };

  return (
    <div>
      <Heading textAlign='center' />
      <GridContainer>
        <GridItem xs={12} sm={12} md={10}>
          <center style={{ margin: '0px 0px -35px 0px' }}>
            <CardHeader paper='true' style={{ color: 'White' }}>
              <h4 style={{ margin: '-40px 10px -20px 0px' }}>
                Welcome To Fynda Page
              </h4>
              <br />
              <p>Helping you find your music community.</p>
            </CardHeader>
          </center>
        </GridItem>
      </GridContainer>
      {/* Fyndya Song and view all page */}
      <Card
        style={{
          borderRadius: '20px 20px 0px 0px',
          margin: '25px -30px',
          width: '117%',
        }}
      >
        <GridContainer>
          <GridItem xs={6}>
            <h3
              style={{
                fontWeight: '600',
                margin: '20px 0px 15px 20px',
                color: '#171055',
              }}
            >
              Fynda Song
            </h3>
          </GridItem>
          <GridItem xs={4}>
            <h2
              style={{
                color: '#555',
                margin: '15px -5px 0px -30px',
                fontWeight: '100',
                background: 'E8E8E8',
                fontSize: '15px',
                textAlign: 'right',
              }}
            >
              Learn more about our featured selections
            </h2>
          </GridItem>
          <GridItem xs={1}>
            <InfoOutlinedIcon
              style={{ color: '#555', margin: '25px 0px 0px 0px' }}
            />
          </GridItem>
        </GridContainer>
        {/* Carousel */}
        <GridContainer
          style={{
            padding: '20px 20px 0px 20px',
            backgroundColor: '#F2F0FD',
          }}
        >
          <GridContainer justify='center'>
            <GridItem xs={12}>
              <GridContainer style={{ margin: '0px 0px 20px 0px' }}>
                <GridItem
                  xs={12}
                  style={{
                    minHeight: '200px',
                  }}
                >
                  {!curated ? (
                    <Loader />
                  ) : !curated.length ? (
                    <MessageInfo text='No tracks found' />
                  ) : (
                    <div>
                      <Hidden xsDown implementation='css'>
                        <div
                          style={{
                            padding: '0px 0px 0px 0px',
                            margin: '0px 0px 20px 0px',
                            borderRadius: '20px',
                          }}
                        >
                          <CarouselDesktop list={curated} />
                        </div>
                      </Hidden>
                      <Hidden smUp implementation='css'>
                        <div
                          style={{
                            padding: '0px 0px 0px 0px',
                            margin: '0px 10px 20px -23px',
                            borderRadius: '20px',
                          }}
                        >
                          <CarouselMobile list={curated} />
                        </div>
                      </Hidden>
                    </div>
                  )}
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </GridContainer>
        {/* Small Screens Fynda Friend */}
        <Hidden mdUp implementation='css'>
          <GridContainer
            style={{
              borderRadius: '-20px 10px 30px 10px',
              padding: '10px 0px 20px 0px',
            }}
          >
            <GridItem xs={6}>
              <h3
                style={{
                  fontWeight: '600',
                  margin: '15px 0px 0px 20px',
                  color: '#171055',
                }}
              >
                Fynda Friend
              </h3>
            </GridItem>
            <GridItem xs={4}>
              <h3
                style={{
                  color: '#555',
                  margin: '20px -30px 0px 0px',
                  fontWeight: '300',
                  color: '#171055',
                  fontSize: '15px',
                  textAlign: 'right',
                }}
              >
                View All
              </h3>
            </GridItem>
            <GridItem xs={2}>
              <ArrowForwardIosRoundedIcon
                style={{ color: '#171055', margin: '18px 0px 0px 11px' }}
              />
            </GridItem>
          </GridContainer>
        </Hidden>
        {/* Large screen for Fynda friends view all  */}
        <Hidden smDown implementation='css'>
          <GridContainer
            style={{
              borderRadius: '-20px 10px 30px 10px',
              padding: '10px 0px 20px 0px',
            }}
          >
            <GridItem xs={6}>
              <h3
                style={{
                  fontWeight: '600',
                  margin: '25px 0px 0px 20px',
                  color: '#171055',
                }}
              >
                Fynda Friend
              </h3>
            </GridItem>
            <GridItem xs={4}>
              <h3
                style={{
                  color: '#555',
                  margin: '30px -30px 0px 0px',
                  fontWeight: '400',
                  color: '#171055',
                  fontSize: '22px',
                  textAlign: 'right',
                }}
              >
                View All
              </h3>
            </GridItem>
            <GridItem xs={2}>
              <ArrowForwardIosRoundedIcon
                style={{ color: '#171055', margin: '34px 0px 0px 11px' }}
              />
            </GridItem>
          </GridContainer>
        </Hidden>
      </Card>

      <GridContainer>
        <GridItem
          style={{
            margin: '-60px -30px 0px -30px',
            width: '120%',
          }}
        >
          <Card
            style={{
              borderRadius: '20px 20px 0px 0px',
              marginBottom: '0px',
            }}
          >
            {matches && !!matches.length && (
              <GridContainer style={{ background: '#F0EFFC' }}>
                <h5
                  style={{
                    margin: '0px 20px 10px 20px',
                    textAlign: 'left',
                    padding: '15px 15px 5px 15px',
                    color: '#171055',
                  }}
                >
                  We think you'll like these people,based on your music tastes
                </h5>
              </GridContainer>
            )}
            <div style={{ paddingBottom: '80px', background: '#F0EFFC' }}>
              {!matches ? (
                <Loader />
              ) : !matches.length ? (
                <MessageInfo text='Mo matches found' />
              ) : (
                <div>
                  {/* Small Screens Fynda Friend */}
                  <Hidden smDown implementation='css'>
                    {matches.map((e) => (
                      <MatchProfileItemLargeScreen key={e.uid} data={e} />
                    ))}
                  </Hidden>
                  {/* Large Screen Fynda Friend */}
                  <Hidden mdUp implementation='css'>
                    {matches.map((e) => (
                      <MatchProfileItemSmallScreen key={e.uid} data={e} />
                    ))}
                  </Hidden>
                </div>
              )}
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

Fynda.defaultProps = {
  favoriteGenres: [],
};

const mapStateToProps = (state) => {
  const { uid } = state.user || {};
  const { curated } = state.providerTracks || {};
  const { favoriteGenres } = state.user || {};
  return { uid, favoriteGenres, curated };
};

export default connect(mapStateToProps, { updateProviderTracks, displayError })(
  Fynda
);
